import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Injector } from '@angular/core';
import { AuthService, guestUser } from 'src/service/auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private router: Router;
  private authService: AuthService;
  constructor(private injector: Injector) {
    this.router = this.injector.get(Router);
    this.authService = this.injector.get(AuthService);
  }
logout() {
    this.authService.logOutUser().subscribe({
      next: (response) => {
        console.log("Logout response: ", response)
        if (response) {
          this.authService.loggedInUser = guestUser;
          localStorage.removeItem("loggedInUser")
        } else {
          console.error("Logout failed");
        }
        console.log ("logout called")
        this.router.navigate(['/login']);
      },
      error: (error) => {
        console.error("Error during logout: ", error);
        console.log ("logout error called")
        this.router.navigate(['/login']);
      }
  
    });
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.log('AuthInterceptor: Intercepting request', request);
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('AuthInterceptor: Caught error', error);
        if (error.status === 401) {
          console.error('AuthInterceptor: Caught error ' + error.status + ' ' + error.statusText);
          // Redirect to login if unauthorized
          this.logout();
        }
        return throwError(() => error);
      })
    );
  }
}


